if (!rtKendo) var rtKendo = {};
if (!rtKendo.debug) rtKendo.debug = {};

rtKendo.grid = {
    onRowClick: function (e, targetUrl, commandId, args) {
        e.preventDefault();
        if (args == '') args = '{}';
        args = JSON.parse(args || '{}');
        args.commandId = commandId;
        $.ajax(
            {
                url: targetUrl,
                "type": "POST",
                "data": args,
                "success": function (header) { rtAPI.call.jqueryProcessResponse(header) },
                "error": function (xhr, ajaxOptions, thrownError) { rtAPI.call.jqueryError(xhr, ajaxOptions, thrownError) }
            }
        )
    }
};

rtKendo.editor = {
    htmxConfigRequest: function (evt) {
        // Find all Kendo Editors within the form or element triggering the request
        $(evt.detail.elt).find("[data-role=editor]").each(function () {
            var editor = $(this).data("kendoEditor");
            if (editor) {
                // Get the ID/Name of the editor and its current value
                var name = $(this).attr("name") || $(this).attr("id");
                var value = editor.value();

                // Inject the value into the HTMX request parameters
                evt.detail.parameters[name] = value;
            }
        });
    }
};

document.addEventListener('DOMContentLoaded', function () { document.body.addEventListener('htmx:configRequest', rtKendo.editor.htmxConfigRequest); });
